import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  FileComment,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files`;

export interface GetFileCommentListQueryArgs {
  fileId: string;
}

export const getFileCommentListRequest = (
  payload: GetFileCommentListQueryArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.fileId}/fileComments`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getFileCommentListQuery = async (
  payload: GetFileCommentListQueryArgs,
): Promise<BackResponse<FileComment[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<FileComment[]>>(
      getFileCommentListRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
